import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CalendarMonthOutlined, ViewListOutlined } from '@mui/icons-material';

export type ResponsesView = 'list' | 'calendar';

interface ResponsesViewToggleProps {
  value: ResponsesView;
  onChange: (value: ResponsesView) => void;
}

export const ResponsesViewToggle: React.FC<ResponsesViewToggleProps> = ({ value, onChange }) => (
  <ToggleButtonGroup
    className="admin-segmented responses-view-toggle"
    value={value}
    exclusive
    size="small"
    onChange={(_e, next) => next && onChange(next)}
  >
    <ToggleButton value="list">
      <ViewListOutlined fontSize="small" />
      List
    </ToggleButton>
    <ToggleButton value="calendar">
      <CalendarMonthOutlined fontSize="small" />
      Calendar
    </ToggleButton>
  </ToggleButtonGroup>
);
